import { Collapse } from 'antd-v5';
import { useRouter } from 'next/router';
import gtm from 'eco-design-reliance/gtm';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

export default function Content() {
    const { t } = useLang('theProduct');
    const { query, locale } = useRouter();
    const faqList = Array.from({ length: 6 }).map((_, idx) => ({
        title: t(`q${idx + 1}`),
        desc: t.rich(`a${idx + 1}`, {
            sn: (v: string) => <a href={`riverpro-serial-number-check${query._timer ? `?_timer=${query._timer}` : ''}`}>{v}</a>,
        }),
        img: idx === 1 ? 'https://websiteoss.ecoflow.com/upload/image/1769478033995/1280X1280.JPEG' : '',
    }));

    return (
        <section
            className={`${css.page} GtmModuleData-section`}
            id="riverpro-firmware-update"
            data-section-id={'riverpro-firmware-update'}
            data-section-title={t('title')}
        >
            <div className="announcement-title">{t('title')}</div>
            <div className="announcement-content">
                <div className="announcement-text">
                    {t.rich('text1', {
                        b: (v: string) => <span>{v}</span>,
                    })}
                </div>
                <div className="announcement-text">{t('text2')}</div>
                <div className="announcement-text">
                    {t.rich('text3', {
                        b: (v: string) => <span>{v}</span>,
                    })}
                </div>
                <div className="announcement-text">{t('text4')}</div>
                <div className="announcement-text">{t('text5')}</div>
                <div className="announcement-text">{t('text6')}</div>
            </div>
            <div className="announcement-content">
                <div className="announcement-text">{t('text7')}</div>
                <div className="announcement-text">{t('text8')}</div>
                <a
                    className="announcement-link gtm-1 GtmModuleData-btn-href"
                    href={`riverpro-firmware-update-guide${query._timer ? `?_timer=${query._timer}` : ''}`}
                    onClick={() => {
                        const href = new URL(`${locale}/riverpro-firmware-update-guide${query._timer ? `?_timer=${query._timer}` : ''}`, window.location.origin)
                            .href;
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'support_navigation',
                            navigation_name: t('link1'),
                            position: 'RiverproFirmwareUpdate_1',
                            next_page_name: href,
                            next_page_type: 'guide',

                            __btn_id1: `gtm-1`,
                            __btn_id2: href,
                            __btn_type: 'href',
                        });
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M14.8707 2.26729V5.86729C14.8707 6.53003 15.4079 7.06729 16.0707 7.06729H19.6707M8.27069 7.06729H10.6707M8.27069 10.6673H15.4707M8.27069 14.2673H15.4707M17.8707 4.06729C17.3366 3.58943 16.7824 3.02267 16.4325 2.65457C16.1997 2.40962 15.8781 2.26729 15.5401 2.26729H6.47041C5.14493 2.26729 4.07041 3.3418 4.07041 4.66727L4.07031 19.0672C4.0703 20.3927 5.14482 21.4672 6.4703 21.4672L17.2703 21.4673C18.5958 21.4673 19.6703 20.3928 19.6704 19.0673L19.6707 6.34512C19.6707 6.03828 19.5536 5.74332 19.3407 5.52242C18.9469 5.11393 18.2893 4.4418 17.8707 4.06729Z"
                            stroke="#3F68E0"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    {t('link1')}
                </a>
            </div>

            <div className="module-title">{t('faq_title')}</div>
            <Collapse
                className="faq-content"
                ghost={true}
                defaultActiveKey={0}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            style={{ transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'all 0.3s' }}
                        >
                            <path
                                d="M12.0747 16.4449C12.3426 16.4449 12.5992 16.3374 12.7871 16.1466L19.2871 9.54651L17.8623 8.14319L12.0747 14.0201L6.28711 8.14319L4.8623 9.54651L11.3623 16.1466L11.436 16.2145C11.6147 16.3628 11.8404 16.4449 12.0747 16.4449Z"
                                fill="black"
                            />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {faqList?.map((list: any, k: number) => (
                    <Collapse.Panel header={list.title} key={k}>
                        {list.desc}
                        {list.img && <img src={list.img} loading="lazy" />}
                    </Collapse.Panel>
                ))}
            </Collapse>

            <div className="announcement-content">
                <div className="module-title">{t('service_title')}</div>
                <ul className="service-list">
                    <li>
                        {t.rich('service1', {
                            // 邮件
                            e: (e: string) => <a href={`mailto:${e}`}>{e}</a>,
                        })}
                    </li>
                    <li>{t('service2')}</li>
                </ul>
                <div className="service-tip">{t('service_tip')}</div>
            </div>

            <a className="announcement-btn" href={`riverpro-serial-number-check${query._timer ? `?_timer=${query._timer}` : ''}`}>
                {t('btn')}
            </a>
        </section>
    );
}
